var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5197 0.480036C15.87 -0.169683 14.8132 -0.158825 14.177 0.504142L10.6945 4.13314L2.19576 1.32061L0.411719 3.10468L7.49567 7.46641L3.9112 11.2016L1.61251 10.8242L0 12.4367L3.37941 13.6203L4.56307 16.9998L6.17558 15.3872L5.7982 13.0886L9.53335 9.50411L13.8951 16.588L15.6791 14.804L12.8666 6.30526L16.4956 2.82275C17.1586 2.18651 17.1694 1.12979 16.5197 0.480036Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/Travel.f54ab741.svg";
export { ForwardRef as ReactComponent };